import React from "react";

const Search = ({setSearchText}) => {
  // Search
  const getSearch = (e) => {
    e.preventDefault();
    const searchValue = e.target.inputValue.value;
    setSearchText(searchValue);
  };
  return (
    <>
      <form onSubmit={getSearch}>
        <div className="form-control">
          <div className="input-group">
            <input
              type="text"
              placeholder="Search ..."
              className="input input-bordered focus:border-primary"
              name="inputValue"
            />
            <label className="btn btn-square btn-primary">
              <input type="submit" value="" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </label>
          </div>
        </div>
      </form>
    </>
  );
};

export default Search;
